import { generateDeviceParams } from 'utils/generateDeviceParams'

export const setCustomAttribute = (name, params) => {
    if (typeof newrelic === 'object') {
        newrelic.setCustomAttribute(name, {
            ...generateDeviceParams(),
            ...params
        })
    }
}

export const recordCustomEvent = (params) => {
    if (typeof newrelic === 'object') {
        const customInteraction = newrelic.interaction();


        const deviceParams = generateDeviceParams()

        const allParams = { ...deviceParams, ...params }

        Object.entries(allParams).forEach(([key, value]) => {
            customInteraction.setAttribute(key, value)
        })

        customInteraction.save();
    }

}

export const noticeError = (
    errorName,
    errorParams: Partial<{
        errorDescription: string
    }>
) => {
    if (typeof newrelic === 'object') {
        newrelic.noticeError(errorName, {
            ...generateDeviceParams(),
            ...errorParams
        })
    }
}
